<template>
  <div>
    <BaseTable
      class="table-shadow"
      :headers="headers"
      :items="info"
      :loading="loading"
      :paginate="true"
      :lastPage="nLastPage"
      @pageChange="fetchParametros(filters, $event)"
    >
      <template v-slot:top>
        <v-toolbar flat>
          <v-toolbar-title>Parâmetros</v-toolbar-title>
          <v-divider class="mx-4" inset vertical></v-divider>
          <v-spacer></v-spacer>
          <RegisterBottom v-can-access="907" @click="openModal('Cadastrar')" />
          <FilterDepartamentos
            @selectedFilters="fetchParametros((filters = $event))"
          />
        </v-toolbar>
      </template>

      <template v-slot:[`item.id_indicador`]="{ item }">
        {{ item.id_indicador }} - {{ item.indicador }}
      </template>
      <template v-slot:[`item.id_band`]="{ item }">
        <BaseSegmento :segmento="item.id_band" />
      </template>
      <template v-slot:[`item.prioridade_indic`]="{ item }">
        <v-icon v-if="item.prioridade_indic == '>'">mdi-greater-than</v-icon>
        <v-icon v-else>mdi-less-than</v-icon>
      </template>
      <template v-slot:[`item.departamento`]="{ item }">
        {{ item.departamento | TitleCase }}
      </template>
      <template v-slot:[`item.mult_empresa`]="{ item }">
        <v-icon :color="status[item.mult_empresa].color">
          {{ status[item.mult_empresa].icon }}
        </v-icon>
      </template>
      <template v-slot:[`item.ativo`]="{ item }">
        <v-chip
          :color="statusAtivo[item.ativo].color"
          dark
          @click="statusItem(item)"
        >
          {{ statusAtivo[item.ativo].text }}
        </v-chip>
      </template>
      <template v-slot:[`item.valor`]="{ item }">
        {{ item.valor.replace(",", ".") | BrazilianCurrency }}
      </template>
      <template v-slot:[`item.valor2`]="{ item }">
        {{ item.valor2 | BrazilianCurrency }}
      </template>
      <template v-slot:[`item.actions`]="{ item }">
        <!-- <v-btn
          v-can-access="909"
          icon
          @click="openModal('Editar', item)"
          color="orange"
          dark
        >
          <v-icon>mdi-pencil</v-icon>
        </v-btn>
        <v-btn
          v-can-access="910"
          icon
          @click="deleteParametros(item.id_funcao_param_depto)"
          color="error"
          small
        >
          <v-icon>mdi-trash-can</v-icon>
        </v-btn>-->

        <IconBottom
          :name="'edit'"
          v-can-access="909"
          @click="openModal('Editar', item)"
        />
        <IconBottom
          :name="'delete'"
          v-can-access="910"
          @click="deleteParametros(item.id_funcao_param_depto)"
        />
      </template>
    </BaseTable>
    <ModalCadastro
      :dialog="dialog"
      :labelBtn="labelBtn"
      :items="items"
      @updateFunctionList="fetchFuncao($event)"
      @closeModal="(dialog = false), fetchParametros()"
    />
  </div>
</template>

<script>
import IconBottom from "@/components/shared/bottons/IconBottom";
import BaseTable from "@/components/shared/NewBaseTable";
import BaseSegmento from "@/components/shared/BaseSegmento";
import RegisterBottom from "@/components/shared/bottons/RegisterBottom";
import ModalCadastro from "./ModalDepartamento";
import FilterDepartamentos from "./FilterDepartamentos";
import comissao from "@/services/http/comissaoService";
import statusItem from "@/mixins/statusItem";
import statusAtivo from "@/mixins/statusAtivo";
import currencyMixin from "@/mixins/currencyMixin";

export default {
  components: {
    BaseTable,
    BaseSegmento,
    RegisterBottom,
    FilterDepartamentos,
    ModalCadastro,
    IconBottom
  },

  mixins: [statusItem, statusAtivo, currencyMixin],

  data() {
    return {
      dialog: false,
      search: "",
      filters: {},
      labelBtn: "",
      items: {},
      loading: false,
      nLastPage: 0,
      headers: [
        { text: "Segmento", value: "id_band", align: "left" },
        { text: "Indicador", value: "id_indicador" },
        { text: "Priorid.", value: "prioridade_indic" },
        { text: "Depto.", value: "departamento" },
        { text: "Tipo Comissão", value: "tipo_comissao" },
        { text: "Tipo Classe", value: "tipo_classe" },
        { text: "Fórmula Meta", value: "formula_meta" },
        { text: "Valor > M", value: "valor", align: "right" },
        { text: "Valor < M", value: "valor2", align: "right" },
        { text: "Status", value: "ativo", align: "center" },
        { text: "Ações", value: "actions", align: "center" }
      ],
      info: []
    };
  },

  methods: {
    openModal(label, items = {}) {
      this.dialog = true;
      this.labelBtn = label;
      this.items = items;
    },
    async fetchParametros(filters, nPage = 1) {
      let { data } = await comissao()
        .funcaoParametrosDepartamentos()
        .show({ page: nPage, ...filters });
      this.nLastPage = data.last_page;
      this.info = data.data;
    },

    async deleteParametros(id) {
      try {
        await this.$swal.confirm(
          "Deseja deletar o parâmetro?",
          "Essa ação não pode ser desfeita"
        );
        await comissao()
          .parametrosDepartamentos(id)
          .delete(null, { notification: true });
        await this.fetchParametros();
      } catch (e) {
        // console.log(e);
      }
    },

    async statusItem(item) {
      await this.$swal.confirm(
        `Atualmente o status é ${item.ativo == "S" ? "ativo" : "inativo"}`,
        `Alterar o status da meta?`
      );
      this.loading = true;
      item.ativo = item.ativo == "S" ? "N" : "S";
      comissao()
        .parametrosDepartamentos(item.id_funcao_param_depto)
        .update(item, { notification: true });
    }
  },

  mounted() {
    this.fetchParametros();
  }
};
</script>

<style></style>
